module.exports = __webpack_public_path__ + "static/logo_makers_mob_dark-d17cffb3de8532047b5e09bfafe66387.png";